import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { useAuth } from './AuthContext';

const SocketContext = createContext();

export const SocketProvider = ({ children }) => {
    const { user } = useAuth();
    const [socket, setSocket] = useState(null);

    useEffect(() => {
        // Only connect if user is authenticated and has a companyId
        if (user && user.companyId) {
            console.log('[SocketContext] Utilisateur authentifié, tentative de connexion...');

            const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
            const serverUrl = isLocalhost ? 'http://localhost:3001' : window.location.origin;

            const newSocket = io(serverUrl, {
                path: '/api/socket.io',
                transports: ['websocket', 'polling']
            });

            setSocket(newSocket);

            newSocket.on('connect', () => {
                console.log('[SocketContext] Connecté au serveur WebSocket avec ID:', newSocket.id);
                newSocket.emit('join_company', user.companyId);
            });

            newSocket.on('connect_error', (error) => {
                console.error('[SocketContext] Erreur de connexion WebSocket:', error.message);
            });

            newSocket.on('disconnect', () => {
                console.log('[SocketContext] Déconnecté du serveur WebSocket');
            });

            return () => {
                newSocket.disconnect();
            };
        }
    }, [user?.id, user?.companyId]);

    const value = React.useMemo(() => ({ socket }), [socket]);
    return (
        <SocketContext.Provider value={value}>
            {children}
        </SocketContext.Provider>
    );
};

export const useSocket = () => {
    return useContext(SocketContext);
};
